import { render, staticRenderFns } from "./cookie-popup.vue?vue&type=template&id=38c03406&"
import script from "./cookie-popup.vue?vue&type=script&lang=ts&"
export * from "./cookie-popup.vue?vue&type=script&lang=ts&"
import style0 from "./cookie-popup.vue?vue&type=style&index=0&id=38c03406&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports